var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgW3 = function SvgW3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1350,
    viewBox: "0 0 810 1012.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.145 278.137h385.71v385.71h-385.71Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405 278.137c-106.512 0-192.855 86.343-192.855 192.855 0 106.508 86.343 192.856 192.855 192.856S597.855 577.5 597.855 470.992c0-106.512-86.343-192.855-192.855-192.855m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.145.137h385.71v385.71H.145Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 .137C86.488.137.145 86.48.145 192.992.145 299.5 86.488 385.848 193 385.848S385.855 299.5 385.855 192.992C385.855 86.48 299.512.137 193 .137m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h386v386H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271 472h268v134H271Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191.922 464.473 252.297-203.024 173.886 216.086L365.812 680.56Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191.922 464.473 252.297-203.024 173.886 216.086L365.812 680.56Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271 336h268v134H271Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191.922 464.473 252.297-203.024 173.886 216.086L365.812 680.56Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w3_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191.922 464.473 252.297-203.024 173.886 216.086L365.812 680.56Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__c)",
    transform: "translate(212 278)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed5c2f",
    d: "M.145.137h385.71v385.71H.145Zm0 0"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff8e9",
    d: "m276.578 472.227-4.996 90.785 17.246-16.239s22.574 32.114 57.402 46.747c34.825 14.632 54.829 11.968 66.579 12.132s45.855-4.593 81.273-30.734c35.418-26.14 44.254-55.758 44.254-55.758l-29.457-13.144s-14.824 35.707-46.645 52.785c-31.82 17.074-45.699 14.265-58.617 15.582-13.023 1.406-57.004-8.582-81.664-36.293l15.285.95Zm0 0"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w3_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff8e9",
    d: "m533.512 469.855 4.996-90.785-17.246 16.239s-22.574-32.114-57.403-46.747c-34.828-14.628-54.804-12.167-66.554-12.332-11.75-.164-45.86 4.594-81.278 30.735-35.414 26.14-44.363 55.848-44.363 55.848l29.543 13.257s14.828-35.71 46.648-52.789c31.82-17.074 45.61-14.375 58.614-15.582 13.027-1.406 57.008 8.582 81.668 36.293l-15.285-.949Zm0 0"
  }))))));
};
export default SvgW3;